import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import { Layout } from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Setups from "./pages/Setups";
import GuideDetail from "./pages/GuideDetail";
import NerdScale from "./pages/NerdScale";
import ForBeginners from "./pages/ForBeginners";
import Articles from "./pages/Articles";
import ArticleDetail from "./pages/ArticleDetail";
import MyAI from "./pages/MyAI";
import About from "./pages/About";
import Subscribe from "./pages/Subscribe";
import ThankYou from "./pages/ThankYou";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/setups" element={<Setups />} />
          <Route path="/guides" element={<Setups />} />
          <Route path="/setups/:slug" element={<GuideDetail />} />
          <Route path="/nerd-scale" element={<NerdScale />} />
          <Route path="/for-beginners" element={<ForBeginners />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/:slug" element={<ArticleDetail />} />
          <Route path="/my-ai" element={<MyAI />} />
          <Route path="/mochi" element={<MyAI />} />
          <Route path="/about" element={<About />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
